import {
  USERS_LOAD_REQUEST,
  USERS_LOAD_SUCCESS,
  USERS_LOAD_FAILURE,
  USERS_ADD_USER,
  USERS_UPDATE_USER
} from '../types/users-types';

const initialState = {
  loading: false,
  error: null,
  users: []
};

function users(state = initialState, action: any = null) {
  switch (action.type) {
    case USERS_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case USERS_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case USERS_LOAD_SUCCESS:
      return {
        ...state,
        users: action.payload,
        loading: false,
        error: null
      };

    case USERS_ADD_USER:
      return {
        ...state,
        users: [action.payload, ...state.users]
      };

    case USERS_UPDATE_USER:
      return {
        ...state,
        users: state.users.map((user: any) => {
          return user.id === action.user.id ? action.user : user;
        })
      };

    default:
      return state;
  }
}

export default users;
